import { getSingleton } from 'fe-lib-singleton';
import { getThemeValue } from './getThemeValueFallback';
import type { ThemeProvider } from 'fe-lib-theme-types';

// Fallback theme provider uses the internal legacy theme
const fallbackProvider = {
  getThemeValue,
  getIsBrand2020Active: () => false,
  subscribe: () => () => undefined
};

export const getThemeProvider = (): ThemeProvider =>
  getSingleton('fe-lib-theme-provider') || fallbackProvider;
